<form [formGroup]='formGroup' class='mb-2'>
  <div class='form-group form-group--treatment'>
    <label [htmlFor]='inputId' [innerHTML]='label' class="form-label"></label>

    <div class='action'>
      <pt-widget-action
        (clickCancel)='clickReset()'
        (clickEdit)='enableEdit.emit()'
        (clickSave)='saveChange.emit()'
        [disabledCancel]='false'
        [disabledEdit]='!enabledEdit'
        [disabledSave]='false'
        [showCancel]='!isDisabled'

        [showEdit]='isDisabled'
        [showIcon]='false'
        [showLoader]='false'

        [showReload]='false'
        [showSave]='!isDisabled'
        actionStyle='TEXT'>
        >
      </pt-widget-action>

    </div>

    <input (click)='inputLink ? clickInput.emit() : null'
           [class.is-invalid]='isChanged && formGroup.invalid'
           [id]='inputId'
           [ngClass]="{'text-black': inputLink && !isDisabled}"
           [readOnly]='inputLink'
           aria-describedby='ptWInputHelp'
           autocomplete='off'
           autofocus
           class='form-control form-control-sm'
           formControlName='value'
           type='{{type}}'
    >
  </div>
</form>
<!--placeholder="{{placeholder}}"-->
